// Generated by scripts/generate-rapids-base-images.mjs. Do not edit manually.

export const RAPIDS_BASE_IMAGE_REPOSITORY = "docker.io/rapidsai/base";
export const RAPIDS_BASE_IMAGE_PATH = "rapidsai/base";
export const RAPIDS_BASE_IMAGE_ARCH = "amd64";

export const rapidsBaseImageOptions = [
  { rapidsVersion: "26.06", pythonVersion: "3.14", cudaVersion: "13" },
  { rapidsVersion: "26.06", pythonVersion: "3.14", cudaVersion: "12" },
  { rapidsVersion: "26.06", pythonVersion: "3.13", cudaVersion: "13" },
  { rapidsVersion: "26.06", pythonVersion: "3.13", cudaVersion: "12" },
  { rapidsVersion: "26.06", pythonVersion: "3.12", cudaVersion: "13" },
  { rapidsVersion: "26.06", pythonVersion: "3.12", cudaVersion: "12" },
  { rapidsVersion: "26.06", pythonVersion: "3.11", cudaVersion: "13" },
  { rapidsVersion: "26.06", pythonVersion: "3.11", cudaVersion: "12" },
  { rapidsVersion: "26.04", pythonVersion: "3.14", cudaVersion: "13" },
  { rapidsVersion: "26.04", pythonVersion: "3.14", cudaVersion: "12" },
  { rapidsVersion: "26.04", pythonVersion: "3.13", cudaVersion: "13" },
  { rapidsVersion: "26.04", pythonVersion: "3.13", cudaVersion: "12" },
  { rapidsVersion: "26.04", pythonVersion: "3.12", cudaVersion: "13" },
  { rapidsVersion: "26.04", pythonVersion: "3.12", cudaVersion: "12" },
  { rapidsVersion: "26.04", pythonVersion: "3.11", cudaVersion: "13" },
  { rapidsVersion: "26.04", pythonVersion: "3.11", cudaVersion: "12" },
  { rapidsVersion: "26.02", pythonVersion: "3.13", cudaVersion: "13" },
  { rapidsVersion: "26.02", pythonVersion: "3.13", cudaVersion: "12" },
  { rapidsVersion: "26.02", pythonVersion: "3.12", cudaVersion: "13" },
  { rapidsVersion: "26.02", pythonVersion: "3.12", cudaVersion: "12" },
  { rapidsVersion: "26.02", pythonVersion: "3.11", cudaVersion: "13" },
  { rapidsVersion: "26.02", pythonVersion: "3.11", cudaVersion: "12" },
  { rapidsVersion: "26.02", pythonVersion: "3.10", cudaVersion: "13" },
  { rapidsVersion: "26.02", pythonVersion: "3.10", cudaVersion: "12" },
  { rapidsVersion: "25.12", pythonVersion: "3.13", cudaVersion: "13" },
  { rapidsVersion: "25.12", pythonVersion: "3.13", cudaVersion: "12" },
  { rapidsVersion: "25.12", pythonVersion: "3.12", cudaVersion: "13" },
  { rapidsVersion: "25.12", pythonVersion: "3.12", cudaVersion: "12" },
  { rapidsVersion: "25.12", pythonVersion: "3.11", cudaVersion: "13" },
  { rapidsVersion: "25.12", pythonVersion: "3.11", cudaVersion: "12" },
  { rapidsVersion: "25.12", pythonVersion: "3.10", cudaVersion: "13" },
  { rapidsVersion: "25.12", pythonVersion: "3.10", cudaVersion: "12" },
] as const;

export type RapidsBaseImageOption = (typeof rapidsBaseImageOptions)[number];
export type RapidsReleaseVersion = RapidsBaseImageOption["rapidsVersion"];

export type RapidsBaseImageSelection = {
  rapidsVersion: RapidsReleaseVersion;
  pythonVersion: string;
  cudaVersion: string;
};
